import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../config/api";
import { BASE_API } from "../../../constants/apiUrls";
import { toast } from "../../../lib/toast";
import {
  CommonParams,
  ErrorMessage,
  GetCommonData,
  Params,
} from "../../../types";
import {
  GetActivityLogData,
  GetUserAccessLog,
  GetUserDetails,
} from "../../../types/settings/settings";
import { handleApiError } from "../../../utils/errorHandler";

//get
export const getAllUserDetailsAsync = createAsyncThunk<
  { data: GetUserDetails[]; length: number },
  Params<CommonParams>,
  { rejectValue: ErrorMessage }
>("admin/getAllUserDetails", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as CommonParams;

  try {
    const response = await AXIOS.get(BASE_API.getUserDetails, {
      params: { ...rest },
      headers: {},
    });
    return {
      data: response.data?.data,
      length: response.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get user details fail");
    return rejectWithValue(error);
  }
});

//get login log
export const getAllLoginAccessLogAsync = createAsyncThunk<
  GetCommonData<GetUserAccessLog>,
  Params<CommonParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin-geo/getAllLoginAccessLog", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as CommonParams;

  try {
    const data = await AXIOS.get(BASE_API.getAccessLog, {
      params: { ...rest },
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get log data fail");
    return rejectWithValue(error);
  }
});

//get activity log
export const getActivityLogAsync = createAsyncThunk<
  GetCommonData<GetActivityLogData>,
  Params<CommonParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin-geo/getActivityLog", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as CommonParams;

  try {
    const data = await AXIOS.get(BASE_API.getActivityLog, {
      params: { ...rest },
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get log data fail");
    return rejectWithValue(error);
  }
});
